export {
  ManifestOverview,
  type ManifestOverviewProps,
} from '../../compositions/my-trips/ManifestOverview';
